import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import sv from "./sv.json";

const detectionOptions = {
  order: ['querystring'],
  lookupQuerystring: 'locale',
  caches: [],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: detectionOptions,
    lng: "sv",
    fallbackLng: "sv",
    resources: {
      en: { translation: en },
      sv: { translation: sv },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
